export const EVENT_LABELS: { [key: string]: string } = {
  activityDeadlineView: 'Activity Deadline View',
  acessibilityButtonClick: 'Accessibility Button Clicked',
  assessmentResultView: 'Assessment Result View',
  buttonClicked: 'Button Clicked',
  contentConsumed: 'Content Consumed',
  contentOpened: 'Content Opened',
  click: 'Click',
  courseProgress: 'Course Progress',
  dexAssessmentModalView: 'Dex Assessment Modal View',
  disciplineProgress: 'Discipline Progress',
  downloadFinished: 'Download Finished',
  forumChannelOpened: 'Forum Channel Opened',
  forumCommentPosted: 'Forum Comment Posted',
  forumTopicCreated: 'Forum Topic Created',
  helloBarViewed: 'Hello Bar Viewed',
  lessonCardClicked: 'LessonCard Clicked',
  lessonPlayed: 'Lesson Played',
  lessonReacted: 'Lesson Reacted',
  linkClicked: 'Link Clicked',
  linkNavigated: 'Link Navigated',
  menuClicked: 'Menu Clicked',
  modalClosed: 'Modal Closed',
  modalCloseAttempt: 'Attempt to close modal',
  modalViewed: 'Modal Viewed',
  noteInteracted: 'Annotation Interacted',
  notificationInteracted: 'Notification Interacted',
  notificationViewed: 'Notification Viewed',
  notebookOpened: 'Notebook Opened',
  notebookInteracted: 'Notebook Interacted',
  microcertificateInteracted: 'Microcertificate Interacted',
  migrationPageAccesed: 'Migration Page Accessed',
  migrationToClassroomCompleted: 'Migration To Classrooms Completed',
  pitchModalView: 'Pitch Modal View',
  pitchSent: 'Pitch Sent',
  postgradContractExtendedSuccessfully: 'Postgrad Contract Extended Successfully',
  postgradContractExtensionButtonVisible: 'Postgrad Contract Extension Button is Visible',
  postgradContractExtensionEligibilityError:
    'Error While Getting Postgrad Contract Extension Eligibility',
  postgradSyncUserCoursesError: 'Error while syncing user courses',
  postgradContractExtensionRequestError: 'Error While Sending Postgrad Contract Extension Request',
  postgradExpiredContractPageView: 'Postgrad Expired Contract Page View',
  postgradRequestContractExtensionSuccessful:
    'Postgrad Request For Contract Extension Was Successful',
  postgradContractExtensionUpdateCheckError:
    'Error While Checking Postgrad Contract Extension Updates',
  postgradSecretaryButtonViewed: 'Postgrad Secretary Button Viewed',
  postgradDocumentsPageError: 'Error While Getting information for document page',
  postgradMicrocertificateEligibilityError:
    'Error While Retrieving Postgrad Microcertificate Eligibility',
  postgradMicrocertificateDownloadError: 'Error While Downloading Postgrad Microcertificate',
  postgradMicrocertificateLinkedinShare: 'Postgrad Microcertificate shared on linkedin',
  postgradMicrocertificateLinkedinShareError:
    'Postgrad Microcertificate error while sharing on linkedin',
  postgradStudyPlanningAnticipated: 'Postgrad Study Planning Week Anticipated',
  postgradStudyPlanningAnticipationCardViewed: 'Postgrad Study Planning Anticipation Card Viewed',
  postgradStudyPlanningAnticipationError: 'Error While Anticipating Study Planning',
  postgradStudyPlanningOptionChosen: 'Postgrad Study Planning Months Option Chosen',
  postgradStudyPlanningBreakpointsError:
    'Error While Retrieving Postgrad Study Planning Breakpoints',
  postgradStudyPlanningSaved: 'Postgrad Study Planning Saved',
  expiredPostgradStudyPlanningCardViewed: 'Expired Postgrad Study Planning Card Viewed',
  refusedPostgradStudyPlanning: 'Refused to Create Postgrad Study Planning',
  reportCardToggle: 'Report Card Toggle',
  reportCardView: 'Report Card View',
  reportCardActivityClick: 'Report Card Activity Click',
  retrievePostgradStudyPlanningError: 'Error While Retrieving Postgrad Study Planning',
  savePostgradStudyPlanningError: 'Error While Saving Postgrad Study Planning',
  skeletonLoadingTime: 'Time of Loading Skeleton',
  smartBannerViewed: 'SmartBanner Viewed',
  smartBannerClicked: 'SmartBanner Clicked',
  studyCaseModalView: 'Study Case Modal View',
  studyCaseSent: 'Study Case Sent',
  studyPlanInteracted: 'Study Plan Interacted',
  tccModalView: 'TCC Modal View',
  tccStart: 'TCC Start',
  tccSendTheme: 'TCC Send Theme',
  tccOrientationStart: 'TCC Orientation Start',
  tccOrientation: 'TCC Orientation',
  tccSendFinal: 'TCC Send Final',
  tccRevaluation: 'TCC Revaluation',
  tccRetry: 'TCC Retry',
  termsOfUseAccepted: 'Terms Of Use Accepted',
  termsOfUseShowUp: 'Terms Of Use Show Up',
  tooltipViewed: 'Tooltip Viewed',
  unableToSelectPostgradStudyPlanningOption:
    'Unable to Select Postgrad Study Planning Months Option',
  documentToastViewed: 'Toast Viewed',
  documentToastClosed: 'Toast Closed',
  postgradStudentDocumentsCertificateDownload: 'Downloading Certificate',
  postgradStudentDocumentsCertificateShareLinkedin: 'Postgrad Certificate Shared on Linkedin',
  postgradStudentDocumentsCertificateShareLinkedinError:
    'Postgrad Certificate Share on Linkedin Error',
  postgradStudentDocumentsError: 'Error While Retrieving Student Documents Status',
  postgradStudentCertificateError: 'Error While Retrieving Certificate Info',
  postgradStudentCertificateDownloadError: 'Error While Downloading Certificate',
  postgradStudentDocumentsVideoError: 'Error While Loading Celebration Video',
  postgradStudentDocumentsVideoWatched: 'Celebration Video Watched',
  unavailableAssessmentsModalView: 'Unavailable Assessments Modal Viewed',
  notificationSent: 'Notification sent',
};
